module.exports = __webpack_public_path__ + "static/media/img.1b50f7fe.png";